import { LOGOUT } from "./constants/loggedOutReasons"
import getProfileApiCall from "./api/getProfile"
import refreshTokenApiCall from "./api/refreshToken"
import _logout from "./utils/logout"
import * as localStorage from "./utils/localStorage"
import { auth } from "./firebase"
import { signOut } from "firebase/auth"

const getProfile = async () => {
  return await getProfileApiCall().catch(() => {
    return
  })
}

const refreshToken = async () => {
  try {
    // Use the refreshTokenApiCall which handles both refresh_token and Firebase token
    const response = await refreshTokenApiCall()
    const { token, refresh_token } = response.data

    localStorage.set("token", token)
    if (refresh_token) {
      localStorage.set("refresh_token", refresh_token)
    }
    localStorage.set("tokenIssuedAt", new Date().toISOString())

    return token
  } catch (error) {
    console.error("Failed to refresh token:", error)
    throw error
  }
}

const login = () => {
  // Login is handled by the Login component
  // The authProvider uses Firebase auth state
  return Promise.resolve()
}

const checkError = async (error) => {
  // Is called everytime when receiving a response from API
  const status = error?.response?.status
  if (status === 401 || status === 403) {
    if (window.refreshingToken) {
      // Skip all failures while token is already being refreshed
      return new Promise(() => {})
    }

    window.refreshingToken = true

    try {
      // Try to refresh the token
      await refreshToken()

      // Check that profile can be fetched after refreshing token
      let profile = await getProfile()

      if (profile) {
        // All good - it was some random API failure
        window.refreshingToken = false
        console.error(error)
        return Promise.resolve()
      }
    } catch (refreshError) {
      console.error("Failed to refresh token:", refreshError)
    }

    // If we get here, either token refresh failed or profile fetch failed
    // Redirect to login page
    window.refreshingToken = false
    await logout()
    return new Promise(() => {})
  }

  return Promise.resolve()
}

const checkAuth = () => {
  // Check if we have a valid token for API communication
  return localStorage.get("token") ? Promise.resolve() : Promise.reject()
}

const logout = async () => {
  try {
    await signOut(auth)
  } catch (error) {
    console.error("Error signing out:", error)
  }
  await _logout(LOGOUT)
}

const getIdentity = () => {
  /* ... */
}

const getPermissions = () => {
  const role = localStorage.getRole()
  return role ? Promise.resolve(role) : Promise.reject()
}

export { refreshToken, login, checkError, checkAuth, logout, getIdentity, getPermissions }
